// extracted by mini-css-extract-plugin
export default {"user_photo":"menu_user_photo__U2-NC"};